import { categoryIcons } from '@Constants/iconMap';
import type { FlowCategory } from '@Types/flowCategory';

/** Shown for a category whose icon is unset or not in the icon map. */
const FALLBACK_ICON = 'circle';

interface FlowCategoryIconsProps {
  categories: FlowCategory[];
}

/** One icon per flow category, in the category's colour, named on hover. */
export function FlowCategoryIcons({ categories }: FlowCategoryIconsProps) {
  if (categories.length === 0) return null;

  return (
    <span className="inline-flex shrink-0 items-center gap-1">
      {categories.map((category) => (
        <span
          key={category.id}
          title={category.name}
          aria-label={category.name}
          style={{ color: category.color }}
          className="inline-flex"
        >
          {(categoryIcons[category.icon] ?? categoryIcons[FALLBACK_ICON]).icon}
        </span>
      ))}
    </span>
  );
}
